import { intersection } from "lodash";
import { ContentTypesEnum, RolePermissions } from "enums";

export const detectHasAnyPermissions = (userPermissions: RolePermissions[], contentType: ContentTypesEnum) => {
  const permissions: { [key in ContentTypesEnum]?: RolePermissions[] } = {
    [ContentTypesEnum.Flows]: [RolePermissions.FlowsView],
    [ContentTypesEnum.AllFlows]: [RolePermissions.FlowsView],
    [ContentTypesEnum.Scheduled]: [RolePermissions.FlowsView],
    [ContentTypesEnum.Events]: [RolePermissions.EventsView],
    [ContentTypesEnum.Surveys]: [RolePermissions.AssetsView],
    [ContentTypesEnum.Assessments]: [RolePermissions.AssetsView],
    [ContentTypesEnum.PDFs]: [RolePermissions.AssetsView],
    [ContentTypesEnum.Uploaded]: [RolePermissions.AssetsView],
    [ContentTypesEnum.Embedded]: [RolePermissions.AssetsView],
    [ContentTypesEnum.Links]: [RolePermissions.AssetsView],
  };

  return intersection(userPermissions, permissions[contentType]).length > 0;
};
